import { useEffect, useRef } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import { sessionState, useChatMessages } from '@chainlit/react-client';

import { OperationSnapshotEntry, snapshotHistoryState } from '@/state/project';

export default function SnapshotHistoryListener() {
  const session = useRecoilValue(sessionState);
  const setSnapshots = useSetRecoilState(snapshotHistoryState);
  const { threadId } = useChatMessages();
  const lastThreadIdRef = useRef<string | undefined>(threadId);

  useEffect(() => {
    if (lastThreadIdRef.current !== threadId) {
      lastThreadIdRef.current = threadId;
      setSnapshots([]);
    }
  }, [threadId, setSnapshots]);

  useEffect(() => {
    const socket = session?.socket;
    if (!socket) return;
    const handler = (payload: { snapshots?: OperationSnapshotEntry[] }) => {
      setSnapshots(payload?.snapshots ?? []);
    };
    socket.on('snapshot_history', handler);
    return () => {
      socket.off('snapshot_history', handler);
    };
  }, [session?.socket, setSnapshots]);

  return null;
}
